// AdminLTE Modules
try {
    // plugins
    require('jquery-slimscroll');
    require('fastclick');
    require('icheck');
    require('admin-lte');
    require('password-strength-meter');

    Cookies = require("js-cookie");
} catch (e) {}

// Sidebar Session State
$.AdminLTESidebarTweak = {};

$.AdminLTESidebarTweak.options = {
    EnableRemember: true,
    NoTransitionAfterReload: false
    //Removes the transition after page reload.
};

if ($.AdminLTESidebarTweak.options.EnableRemember) {
    var re = new RegExp('toggleState' + "=([^;]+)");

    var toggleState = Cookies.get('toggleState');
    if (toggleState == 'closed') {
        if ($.AdminLTESidebarTweak.options.NoTransitionAfterReload) {
            $("body").addClass('sidebar-collapse hold-transition').delay(50).queue(function(){
                $(this).removeClass('hold-transition');
            });
        } else {
            $("body").addClass('sidebar-collapse');
        }
    } else {
        $("body").removeClass('sidebar-collapse');
    }
    
    $("body").on("collapsed.pushMenu expanded.pushMenu", function() {
        var toggleState = 'opened';
        if ($("body").hasClass('sidebar-collapse')) {
            toggleState = 'closed';
        }
        Cookies.set('toggleState', toggleState);
    });
}

// Initialise Helpers
// Image Lazy Load
_.defer(function () {
    const observer = lozad();
    observer.observe();
});
// Enable iCheck
$('.icheck').iCheck({
    checkboxClass: 'icheckbox_flat-purple',
    radioClass: 'iradio_flat-purple',
    increaseArea: '20%' // optional
});
